import React, { useState, useEffect, useRef } from 'react';

import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { useTranslation } from 'react-i18next';


import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import EventBus from "../../common/EventBus";
import { Toast } from 'primereact/toast';
import AuthService from '../../security/AuthService';
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import AccountService from '../../service/AccountService';
import utils from '../../constants/utils';
import Constants from '../../constants/Constants';
import CompanyService from '../../service/CompanyService';
import { Link, useNavigate } from 'react-router-dom';
import { MultiSelect } from 'primereact/multiselect';
import { Checkbox } from 'primereact/checkbox';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import CustomConfirmDialog from '../../components/CustomConfirmDialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { set } from 'date-fns';

export const AccountManagement = (props) => {

    const navigate = useNavigate();

    const { t } = useTranslation();
    const toast = useRef(null);
    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);
    const [filters, setFilters] = useState(null);

    const [status, setStatus] = useState('N');

    const [accountList, setAccountList] = useState([]);
    const [selectedAccounts, setSelectedAccounts] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState([]);
    const [loadingApprovalList, setLoadingApprovalList] = useState(true);

    const [displayAccountDialog, setDisplayAccountDialog] = useState(false);

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [webSite, setWebSite] = useState('');
    const [userName, setUserName] = useState('');

    const [userTypes, setUserTypes] = useState(Constants.userTypes);
    const [userType, setUserType] = useState('');


    const [companyType, setCompanyType] = useState();
    const [companyName, setCompanyName] = useState('');
    const [companyId, setCompanyId] = useState(null);

    const [title, setTitle] = useState('');
    const [companyWebSite, setCompanyWebSite] = useState('');

    const [address, setAddress] = useState('');

    const [companyTypes, setCompanyTypes] = useState([]);
    const [selectedCompanyType, setSelectedCompanyType] = useState();

    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');

    const [hasBluetick, setHasBluetick] = useState(false);

    const [newstatus, setNewstatus] = useState(true);
    const [roles, setRoles] = useState(null);
    const [selectedRoles, setSelectedRoles] = useState(null);
    const [message, setMessage] = useState("");

    console.log("AccountManagement selected Accounts", selectedAccounts)




    useEffect(() => {
        loadAll();

    }, []);

    const loadAll = () => {
        onLoadData(status);
        loadCompanyTypes();
        loadRoles();
    }

    const showLoading = () => {
        setDisplayLoadingDialog(true);
    }
    const hideLoading = () => {
        setDisplayLoadingDialog(false);
    }




    const reject = () => {
        console.log("reject");
        setVisible(false);
        setActionParam('');
        setMessage('');
    };



    const onLoadData = (param) => {
        setDisplayLoadingDialog(true);
        setAccountList([]);
        setSelectedAccounts([]);
        setSelectedAccount(null);
        AccountService.inquireUserbyValidation(param).then(
            (response) => {
                console.log("inquireUserbyValidation", response)
                console.log("inquireUserbyValidation", response?.data?.data?.dataList)
                if (response?.data?.data?.dataList?.length > 0) {
                    console.log("set inquireUserbyValidation", response?.data?.data?.dataList)
                    setAccountList(response?.data?.data?.dataList);
                }
                setDisplayLoadingDialog(false);
            },
            (error) => {
                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquireapprovallistbystatus logout******")
                    EventBus.dispatch("logout", props);
                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );


    }
    const loadCompanyTypes = () => {
        console.log("companyTypes", companyTypes, companyTypes?.length)
        if (companyTypes?.length === 0) {
            showLoading();
            CompanyService.inquiereCompanyTypes().then(
                (response) => {
                    console.log("inquiereCompanyTypes", response?.data?.data?.dataList)
                    if (response?.data?.data?.dataList?.length > 0) {
                        let _companyTypes = response?.data?.data?.dataList;
                        setCompanyTypes(_companyTypes);
                    }
                    hideLoading();
                },
                (error) => {
                    hideLoading();
                    console.log("errror", error);
                    const _content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    console.log(_content);

                    if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                        console.log("do loggout");
                        navigate('/')
                    } else {
                        toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                    }
                }
            );

        }
    }
    const loadRoles = () => {
        console.log("loadRoles", roles)
        if (!roles || roles?.length === 0) {
            showLoading();
            AccountService.inquireRoles().then(
                (response) => {
                    console.log("inquireRoles", response?.data?.data?.dataList)
                    if (response?.data?.data?.dataList?.length > 0) {
                        let _roles = response?.data?.data?.dataList;
                        setRoles(_roles);
                    }
                    hideLoading();
                },
                (error) => {
                    hideLoading();
                    console.log("errror", error);
                    const _content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    console.log(_content);

                    if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                        console.log("do loggout");
                        navigate('/')
                    } else {
                        toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                    }
                }
            );

        }
    }

    const exportToExcel = () => {
        console.log("exportexcel", accountList);

        if (accountList != null) {
            import('xlsx').then(xlsx => {
                const worksheet = xlsx.utils.json_to_sheet(accountList);
                const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
                const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
                saveAsExcelFile(excelBuffer, 'Approval List');
            });
        }
    }


    const saveAsExcelFile = (buffer, fileName) => {

        import('file-saver').then(module => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
            }
        });

    }



    const onUpdateApprovalListStatus = (_selectedAccount, newStatus) => {

        console.log("onUpdateApprovalListStatus actionParam ", actionParam,actionParam === "R" , message , message.length < 10);

        if (_selectedAccount || selectedAccounts?.length > 0) {
            let _message = message;
          /*  if (actionParam === "Y") {
                _message = "";
            }*/
            console.log("onUpdateApprovalListStatus ff1",actionParam == "R" );
            console.log("onUpdateApprovalListStatus ff2",message );
            console.log("onUpdateApprovalListStatus ff3", message.length < 10);
            if ( actionParam == "R" && message.length < 10) {
                 console.log("onUpdateApprovalListStatus actionParam xxxxxxxxxx R");
                toast.current.show({ severity: 'error', summary: t("global_error"), detail: t("global_error_confirm_meessage"), life: 5000 });
                return;
            }
            if (actionParam == "Y" &&  message.length < 10) {
                toast.current.show({ severity: 'error', summary: t("global_error"), detail: t("global_approve_confirm_meessage"), life: 5000 });
                return;
            }

            

            let _userList = [];
            if (_selectedAccount) {
                const apiParams = { id: _selectedAccount.id, email: _selectedAccount.email, active: newStatus, isValidated: newStatus, apprMessage: _message };
                _userList.push(apiParams);
            } else {
                for (let index = 0; index < selectedAccounts?.length; index++) {
                    const element = selectedAccounts[index];
                    const apiParams = { id: element.id, email: element.email, active: newStatus, isValidated: newStatus, apprMessage: _message };
                    _userList.push(apiParams);
                }
            }




            let _updateRequest = { users: _userList }

            AccountService.updateUsers(_updateRequest).then(
                (response) => {
                    console.log("updateUsers", response)
                    onLoadData(status);
                    setVisible(false);
                },
                (error) => {
                    const _content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    console.log(_content);

                    if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                        EventBus.dispatch("logout", props);

                    } else {
                        toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                    }
                }
            );
        } else {
            console.log("Select Approvallist");
        }

    }


    const leftToolbarTemplate = () => {
        return (
            <h5>{t('global_text_accountsettings')}</h5>
        )
    }
    const onStatusChange = (param) => {

        setStatus(param);
        onLoadData(param);
    }

    const rightToolbarTemplate = () => {


        return (
            <React.Fragment>
                <span className="p-buttonset pr-3">
                    <Button label={t("filter_appointment_pending")} icon="fa fa-clock" disabled={status === 'N'} onClick={() => onStatusChange("N")} />
                    <Button label={t("filter_appointment_approved")} icon="fa fa-check" disabled={status === 'Y'} onClick={() => onStatusChange("Y")} />
                    <Button label={t("filter_appointment_not_approved")} icon="fa fa-times" disabled={status === 'R'} onClick={() => onStatusChange("R")} />
                </span>
                <Button type="button" icon="fa fa-file-excel" onClick={exportToExcel} className="mr-2" title={t('export_to_excel')} />
            </React.Fragment>
        )
    }

    const doAction = (rowData, actionParam) => {
        console.log("doAction", rowData, actionParam);
        setActionParam(actionParam);
        setVisible(true);;
        setMessage('');
        let _accountList = [];
        _accountList.push(rowData);
        setSelectedAccounts(_accountList);

    }

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="fa fa-check" className="p-button-rounded p-button-success p-button-outlined mr-2 mb-2" onClick={() => doAction(rowData, "Y")} />
                <Button icon="fa fa-times" className="p-button-rounded p-button-danger p-button-outlined mr-2 mb-2" onClick={() => doAction(rowData, "R")} />
                <Button icon="fa fa-edit" className="p-button-rounded p-button-secondary p-button-outlined mr-2 mb-2" onClick={() => onAccountSelect(rowData)} />

            </React.Fragment>
        );
    }


    const statusBodyTemplate = (data) => {
        return (
            <>
                <div>
                    <span style={
                        { color: data?.active === 'Y' ? '#0BD18A' : '#FC6161' }}>{t('global_text_active_' + data?.active)}</span>
                </div>


            </>
        )
    };


    const companyTypeTemplate = (data) => {
        return (
            <>
                <div>
                    {t('global_text_' + data?.userType)}
                </div>


            </>
        )
    };
    const validateBodyTemplate = (data) => {
        return (
            <>
                <div>
                    <span style={
                        { color: data?.isValidated === 'Y' ? '#0BD18A' : '#FC6161' }}>{t('global_text_validate_' + data?.isValidated)}</span>
                </div>


            </>
        )
    };


    const dateTemplate = (rowData) => {
        return utils.formatDateTime(new Date(rowData.cdate));
    }
    const udateTemplate = (rowData) => {
        if (rowData.udate) {
            return utils.formatDateTime(new Date(rowData.udate));
        }
        return null;
    }

    const onHideDialog = () => {

        setDisplayAccountDialog(false);
    }
    const onAccountSelect = (param) => {
        console.log("onAccountSelect", param);
        defaultDialogData();
        setSelectedAccount(param);

        setFirstName(param.firstName);
        setLastName(param.lastName);
        setUserName(param.userName);
        setEmail(param.email);
        setWebSite(param.webSite);
        setCompanyId(param.companyId);
        setCompanyType(param.companyType);
        setCompanyName(param.companyName);
        setTitle(param.title);
        setCompanyWebSite(param.companyWebSite);
        setAddress(param.address);
        // setSelectedCompanyType(param.selectedCompanyType);

        setSelectedRoles(param.roles);
        setNewstatus(false);
        setDisplayAccountDialog(true);
        setHasBluetick(param?.hasBluetick == 1 ? true : false);


        userTypes.map((_userType, index) => {
            if (_userType.type === param.userType) {
                setUserType(_userType);
            }
        });
        companyTypes.map((_companyType, index) => {
            console.log("_companyType", _companyType, param.companyCode)

            if (_companyType.code === param.companyCode) {
                setSelectedCompanyType(_companyType);
            }
        });

    }
    const defaultDialogData = () => {


        setFirstName('');
        setLastName('');
        setUserName('');
        setEmail('');
        setWebSite('');

        setNewstatus(true);


    }
    const actionFooter = () => {
        if (newstatus) {
            return (
                <div className="grid">

                </div>
            )
        } else {
            return (
                <div className="grid">
                    <div className="col-12 md:col-4">
                        <Button label={t('global_btn_update')} icon="fa fa-save" className="p-button" onClick={onUpdateAccount}></Button>
                    </div>
                    <div className="col-12 md:col-4">
                        <Button label={selectedAccount?.active === 'Y' ? t('global_btn_passive') : t('global_btn_active')} icon="fa fa-times-circle" className="p-button" onClick={() => onUpdateAccount(selectedAccount?.active === 'Y' ? 'N' : 'Y')}></Button>
                    </div>
                    <div className="col-12 md:col-4">
                        <Button label={t('global_btn_cancel')} icon="fa fa-ban" className="p-button" onClick={() => onHideDialog('displayHospitalDialog')}></Button>
                    </div>
                </div>
            )
        }
    }

    const onUpdateAccount = () => {

        console.log(userType.type, firstName, lastName, email)


        console.log("onUpdateAccount");
        if (firstName?.length > 0 && lastName?.length > 0 && email?.length > 0) {
            setDisplayLoadingDialog(true);

            const apiParams = {
                id: selectedAccount.id, userType: userType.type, firstName: firstName, lastName: lastName, email: email,
                roles: selectedRoles, hasBluetick: hasBluetick ? 1 : 0
            };
            if (userType.type === 'company') {
                apiParams.title = title;
                apiParams.companyName = companyName;
                if (companyId) {
                    apiParams.companyId = companyId;
                }
                //
                apiParams.companyType = selectedCompanyType.id;

                apiParams.address = address;
                //  apiParams.companyPhoneNumber = companyPhoneNumber;
                apiParams.companyWebSite = companyWebSite;

            }
            if (selectedRoles) {
                //   apiParams.roles={roles:selectedRoles};

            }
            let _userList = [];
            _userList.push(apiParams);

            let _updateRequest = { users: _userList }

            AccountService.updateUsers(_updateRequest).then(

                (response) => {

                    console.log("updateUsers", response);

                    if (response?.data?.error) {
                        setDisplayLoadingDialog(false);

                        let _detail = response.data.error?.innerExceptionMessage;
                        if (t(_detail)) {
                            _detail = t(_detail);
                        }


                        toast.current.show({ severity: 'error', summary: t('global_text_errorsummary'), detail: _detail, life: 10000 });
                    } else {
                        console.log("onRegister", response);
                        loadAll();

                        setDisplayLoadingDialog(false);
                        setDisplayAccountDialog(false);

                        toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: t('global_success'), life: 3000 });
                    }
                },
                (error) => {
                    setDisplayLoadingDialog(false);

                    const _content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    console.log(_content);

                    if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                        EventBus.dispatch("logout", props);

                    } else {
                        toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                    }
                }
            );
        } else {
            toast.current.show({ severity: 'error', summary: t("global_error"), detail: t("global_error_detail"), life: 5000 });

        }

    }
    const onSelectUserType = (param) => {




        if (param === 'artlover') {
            // setEmail(usermail);
        } else {

        }

        setUserType(param);
        console.log("test palette", param)
        if (param === 'company') {
            // loadData();
        }


    }
    const selectedUserTypeTemplate = (option, props) => {
        if (option) {
            return (
                <div>{t(option.descr)}</div>
            );
        }

        return <span>{props.placeholder}</span>;
    };
    const userTypeOptionTemplate = (option) => {
        return (
            <div>{t(option.descr)}</div>
        );
    };
    const onSelectedCompanyType = (param) => {
        console.log("onSelectedCompanyType", param)
        setSelectedCompanyType(param);
        setCompanyType(param.id);

    }


    const [visible, setVisible] = useState(false);
    const [actionParam, setActionParam] = useState("");

    const userProfileTemplate = (rowData) => {
        return (
            <a target='_blank'  href={"/profile/" + rowData.id + "/" +rowData.userType} className="flex align-items-center hover:text-gray-400 transition-duration-200 mt-2">
               {rowData.email}
            </a>
        );
    };

    const renderContacts = () => {

        if (selectedAccount?.details?.contacts?.length > 0) {
            let _contacts = selectedAccount?.details?.contacts;
            return (
                _contacts?.map((param, index) => {
                    let _ico =
                        param?.code === "behance.net" ? "fa-brands fa-behance" :
                            param?.code === "facebook.com" ? "fa-brands fa-facebook" :
                                param?.code === "instagram.com" ? "fa-brands fa-instagram" :
                                    param?.code === "youtube.com" ? "fa-brands fa-youtube" :
                                        param?.code === "deviantart.com" ? "fa-brands fa-deviantart" :
                                            param?.code === "linkedin.com" ? "fa-brands fa-linkedin" :
                                                param?.code === "twitter.com" ? "fa-brands fa-twitter" :
                                                    param?.code === "x.com" ? "fa-brands fa-x-twitter" :
                                                        param?.code === "flickr.com" ? "fa-brands fa-flickr" :
                                                            param?.code === "soundcloud.com" ? "fa-brands fa-soundcloud" :
                                                                param?.code === "vimeo.com" ? "fa-brands fa-vimeo-v" :
                                                                    param?.code === "spotify.com" ? "fa-brands fa-spotify" :
                                                                        param?.code === "pinterest.com" ? "fa-brands fa-pinterest" :
                                                                            param?.code === "tiktok.com" ? "fa-brands fa-tiktok" :
                                                                                param?.code === "snapchat.com" ? "fa-brands fa-snapchat" :
                                                                                    "fas fa-globe";



                    return (
                        <Link key={index} to={param?.val} target="_blank">
                            <Button icon={_ico} className={"p-button-rounded p-button-header mr-2 mb-2"} >
                            </Button>
                        </Link>
                    )
                })
            )

        }

    }

    return (
        <div className="layout-dashboard">

            <div className="grid">
                <Toast ref={toast} />

                <div className="col-12">
                    <div className="card">
                        <Toolbar className="mb-4" start={leftToolbarTemplate} end={rightToolbarTemplate}></Toolbar>

                        <Dialog
                            visible={visible}
                            onHide={() => { if (!visible) return; setVisible(false); setActionParam(''); setMessage(''); }}
                            headerStyle={{ display: 'none', background: 'transparent' }}
                            style={{ padding: '0px' }}
                            contentStyle={{ padding: '0px', background: 'transparent' }}
                        >
                            <div className="flex flex-column align-items-center p-5 surface-overlay border-round mt-7">
                                <div className="border-circle bg-primary inline-flex justify-content-center align-items-center h-6rem w-6rem -mt-8">
                                    <i className="pi pi-question text-5xl"></i>
                                </div>
                                <span className="font-bold text-2xl block mb-2 mt-4" >
                                    {t('global_text_confirm_header')}
                                </span>
                                <p className="mb-0" >
                                    {t('global_text_confirm_message')}
                                </p>
                                    <InputTextarea value={message} onChange={(e) => setMessage(e.target.value)} className="w-full mt-4"
                                        rows={5} cols={50} placeholder={t('global_text_confirm_placeholder')} />

                                <div className="flex align-items-center gap-2 mt-4 w-12 justify-content-between">
                                    <Button
                                        label={t('global_btn_approve')}
                                        onClick={(event) => {
                                            // hide(event);
                                            onUpdateApprovalListStatus(null, actionParam);
                                        }}
                                        className="w-8rem"
                                    ></Button>
                                    <Button
                                        label={t('global_btn_cancel')}
                                        outlined
                                        onClick={(event) => {
                                            //   hide(event);
                                            reject();

                                        }}
                                        className="w-8rem"
                                    ></Button>
                                </div>
                            </div>

                        </Dialog>
                        <div className="flex justify-content-end align-items-center mb-4 gap-2">
                            <Button icon="fa fa-check" className="p-button-rounded p-button-success p-button-outlined mr-2 mb-2"
                                disabled={selectedAccounts.length === 0}
                                onClick={() => { setActionParam('Y'); setVisible(true);; setMessage(''); }} />
                            <Button icon="fa fa-times" className="p-button-rounded p-button-danger p-button-outlined mr-2 mb-2"
                                disabled={selectedAccounts.length === 0}
                                onClick={() => { setActionParam('R'); setVisible(true); setMessage(''); }} />
                        </div>

                        <DataTable value={accountList} paginator className="p-datatable-customers" showGridlines rows={10}
                            dataKey="id" filters={filters} filterDisplay="menu" loading={displayLoadingDialog}
                            emptyMessage={t('global_text_no_found')} rowHover selection={selectedAccounts}
                            onSelectionChange={e => setSelectedAccounts(e.value)}

                            selectionMode={'checkbox'}

                        >
                            <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>

                            <Column field="userType" header={t('global_text_usertype')} filter filterPlaceholder={t('global_text_usertype')} body={companyTypeTemplate} style={{ minWidth: '12rem' }} />

                            <Column field="firstName" header={t('global_text_firstname')} filter filterPlaceholder={t('global_text_firstname')} style={{ minWidth: '12rem' }} />
                            <Column field="lastName" header={t('global_text_lastname')} filter filterPlaceholder={t('global_text_lastname')} style={{ minWidth: '12rem' }} />

                            <Column field="companyName" header={t('register_company_name')} filter filterPlaceholder={t('register_company_name')} style={{ minWidth: '12rem' }} />
                            <Column field="userName" header={t('global_text_user_name')} filter filterPlaceholder={t('global_text_user_name')} style={{ minWidth: '12rem' }} />

                            <Column field="email" header={t('global_text_email')} filter filterPlaceholder={t('global_text_email')} style={{ minWidth: '12rem' }} body={userProfileTemplate}/>

                            <Column field="cdate" header={t('global_text_cdate')} filter filterPlaceholder={t('global_text_cdate')} body={dateTemplate} />
                            <Column field="udate" header={t('global_text_udate')} filter filterPlaceholder={t('global_text_udate')} body={udateTemplate} />
                            <Column field="uuser" header={t('global_text_uuser')} filter filterPlaceholder={t('global_text_uuser')} />

                            <Column field="status" header={t('global_text_status')} filter body={statusBodyTemplate} />
                            <Column field="isValidated" header={t('global_text_validation_status')} filter body={validateBodyTemplate} />

                            <Column body={actionBodyTemplate} exportable={false} style={{ minWidth: '8rem' }}></Column>


                        </DataTable>

                    </div>
                </div>
                <Dialog visible={displayAccountDialog} onHide={() => onHideDialog()} breakpoints={{ '960px': '75vw' }} style={{ width: '50vw' }} >
                    <div className="grid">
                        <div className="col-12">
                            <div className="card p-fluid">
                                <h5>{t('global_text_accountsettings')}</h5>

                                <div className="field grid">
                                    <label className="col-12 mb-2 md:col-2 md:mb-0">{t('global_text_usertype')}</label>
                                    <div className="col-12 md:col-10">
                                        <Dropdown id="user_type" value={userType} itemTemplate={userTypeOptionTemplate}
                                            valueTemplate={selectedUserTypeTemplate}
                                            onChange={(e) => onSelectUserType(e.value)} options={userTypes} optionLabel="type"
                                            placeholder={t('global_text_selectone')} ></Dropdown>
                                    </div>
                                </div>
                                <div className="field grid">
                                    <label htmlFor="firstName" className="col-12 mb-2 md:col-2 md:mb-0">{t('global_text_firstname')}</label>
                                    <div className="col-12 md:col-10">
                                        <InputText id="firstName" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                    </div>
                                </div>
                                <div className="field grid">
                                    <label htmlFor="lastName" className="col-12 mb-2 md:col-2 md:mb-0">{t('global_text_lastname')}</label>
                                    <div className="col-12 md:col-10">
                                        <InputText id="lastName" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                    </div>
                                </div>
                                <div className="field grid">
                                    <label htmlFor="email" className="col-12 mb-2 md:col-2 md:mb-0">{t('global_text_email')}</label>
                                    <div className="col-12 md:col-10">
                                        <InputText id="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="off" />

                                    </div>
                                </div>
                                <div className="field grid">
                                    <label htmlFor="website" className="col-12 mb-2 md:col-2 md:mb-0">{t('global_text_website')}</label>
                                    <div className="col-12 md:col-10">
                                        <InputText id="website" value={webSite} onChange={(e) => setWebSite(e.target.value)}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>

                                <div className="field grid">
                                    <label htmlFor="userName" className="col-12 mb-2 md:col-2 md:mb-0">{t('global_text_user_name')}</label>
                                    <div className="col-12 md:col-10">
                                        <InputText id="userName" value={userName} onChange={(e) => setUserName(e.target.value)}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>
                                {userType.type === 'company' && (<>
                                    <div className="field grid">
                                        <label htmlFor="selectedCompanyType" className="col-12 mb-2 md:col-2 md:mb-0">{t('register_company_type')}</label>
                                        <div className="col-12 md:col-10">
                                            <Dropdown id="selectedCompanyType" value={selectedCompanyType} onChange={(e) => onSelectedCompanyType(e.value)} options={companyTypes} optionLabel="name"
                                                placeholder={t('register_company_type')} filter
                                                className="w-full  inputtext_raunded" />
                                        </div>
                                    </div>

                                    <div className="field grid">
                                        <label htmlFor="companyName" className="col-12 mb-2 md:col-2 md:mb-0">{t('register_company_name')}</label>
                                        <div className="col-12 md:col-10">

                                            <InputText id="companyName" value={companyName} onChange={(e) => setCompanyName(e.target.value)}
                                                className="inputtext_raunded p-inputtext " type="text" placeholder={t('register_company_name')}></InputText>
                                        </div>
                                    </div>

                                    <div className="field grid">
                                        <label htmlFor="title" className="col-12 mb-2 md:col-2 md:mb-0">{t('register_title')}</label>
                                        <div className="col-12 md:col-10">
                                            <InputText id='title' value={title} onChange={(e) => setTitle(e.target.value)}
                                                type="text" placeholder={t('register_title')} className="inputtext_raunded p-inputtext " />
                                        </div>
                                    </div>

                                    <div className="field grid">
                                        <label htmlFor="companyWebSite" className="col-12 mb-2 md:col-2 md:mb-0">{t('global_text_website')}</label>
                                        <div className="col-12 md:col-10">
                                           {renderContacts()}
                                        </div>
                                    </div>


                                </>)
                                }
                                <div className="field grid">
                                    <label htmlFor="role" className="col-12 mb-2 md:col-2 md:mb-0">{t('global_text_role')}</label>
                                    <div className="col-12 md:col-10">
                                        <MultiSelect value={selectedRoles} onChange={(e) => setSelectedRoles(e.value)} options={roles} optionLabel="description" display="chip"
                                            placeholder={t('global_text_selectone')} maxSelectedLabels={3} className="w-full inputtext_raunded" />

                                    </div>
                                </div>
                                <div className="field grid">
                                    <label htmlFor="role" className="col-12 mb-2 md:col-2 md:mb-0">{t('global_text_bluetick')}</label>
                                    <div className="col-12 md:col-10">
                                        <Checkbox inputId="binary" checked={hasBluetick} onChange={e => setHasBluetick(e.checked)} />

                                    </div>
                                </div>


                                {actionFooter()}


                            </div>

                        </div>
                    </div>

                </Dialog>
            </div>
        </div>
    )
}